module.exports = __webpack_public_path__ + "media/future.2be1cb21.png";